import * as React from 'react';
import '../../Styles/component/misc/announcement.sass';
import {useEffect, useState} from "react";

import {RequestApi, RequestMethod} from '../../Util/RequestApi';

export const StatusMessages = () => {
    const [statusMessages, setStatusMessages] = useState<undefined | string>();

    useEffect(() => {
        RequestApi.fetch(RequestMethod.get, 'api/messages').then(async (response: Response) => {
            if (response.status !== 200) {
                return;
            }

            setStatusMessages(await response.text());

            setTimeout(
                () => {
                    setStatusMessages(undefined);
                },
                3000,
            );
        });
    }, []);

    return (
        statusMessages === undefined ? <React.Fragment /> : <div className="announcement__wrapper" dangerouslySetInnerHTML={{__html: statusMessages}}/>
    );
};
